/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'

function Shareholder(props) {
  return (
    <div>Shareholder</div>
  )
}

Shareholder.propTypes = {}

export default Shareholder
